import img1 from '../images/icon/wallet.png';
import img2 from '../images/icon/shopping-cart.png';
import img3 from '../images/icon/folder.png';
import img4 from '../images/icon/money-bag.png';

const dataPortfolio = [
    {
        img: img1,
        step:'Step 01',
        title : 'Connect Your Wallet',
        desc: 'Oficia dese runt mollit anim id est labo met, conse ctetur adipi smod tempor inc ididunt ut labore et dolore quis'
    },
    {
        img: img2,
        step:'Step 02',
        title : 'Buy Your NFT',
        desc: 'Oficia dese runt mollit anim id est labo met, conse ctetur adipi smod tempor inc ididunt ut labore et dolore quis'
    },
    {
        img: img3,
        step:'Step 03',
        title : 'Create Collection',
        desc: 'Oficia dese runt mollit anim id est labo met, conse ctetur adipi smod tempor inc ididunt ut labore et dolore quis'
    },
    {
        img: img4,
        step:'Step 04',
        title : 'Sell Your NFT',
        desc: 'Oficia dese runt mollit anim id est labo met, conse ctetur adipi smod tempor inc ididunt ut labore et dolore quis'
    },
]

export default dataPortfolio;